"use client";

import React, { useEffect, useState } from "react";
import styles from "../VideoSection.module.css";

interface CountUpGroupProps {
  infoList: any[];
  isActive: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  style?: React.CSSProperties;
}

export function CountUpGroup({
  infoList = [],
  isActive,
  isDesktop,
  isTablet,
  style,
}: CountUpGroupProps) {
  const [values, setValues] = useState<number[]>([]);
  const duration = 2000;

  useEffect(() => {
    // Xử lý loại bỏ dấu phẩy để parse số chính xác (ví dụ: "60,000" -> 60000)
    const targets = infoList.map((info) => {
      const val = String(info?.title || "0").replace(/,/g, "");
      return parseFloat(val) || 0;
    });

    if (!isDesktop) {
      setValues(targets);
      return;
    }

    if (isActive) {
      const startTime = performance.now();

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3); // Cubic ease out

        const newValues = targets.map((t) => Math.floor(eased * t));
        setValues(newValues);

        if (progress < 1) requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    } else {
      setValues(Array(infoList.length).fill(0));
    }
  }, [isActive, infoList, isDesktop]);

  // Strip HTML from content if needed
  const stripHTML = (html: string) => {
    if (typeof document === "undefined") return html;
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const numberFontSize = isDesktop ? "44px" : isTablet ? "34px" : "26px";

  return (
    <div className={styles.count_up_grid} style={style}>
      {infoList.map((info, index) => {
        const numberText = info?.title;
        const isNumber = !isNaN(Number(numberText));

        return (
          <div key={index} className={styles.count_item}>
            <h2
              className={styles.count_number}
              style={{ fontSize: numberFontSize }}
            >
              {isNumber
                ? values[index]?.toLocaleString("en-US") || 0
                : numberText}
              <span className={styles.count_plus}>+</span>
            </h2>
            <p className={styles.count_label}>{stripHTML(info?.content)}</p>
          </div>
        );
      })}
    </div>
  );
}
